import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import { AppBar, Tabs, Tab, Box } from "@material-ui/core";
import "./Reports.scss";
import { useSelector } from "react-redux";
import BaseReport from "./ReportsTab/BaseReport";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={0}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function Reports() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const siteToken = useSelector((state) => state.saveTokenReducer);
  useEffect(() => {
    if (siteToken) {
     
    }
  }, [siteToken]);
  return (
    <div className={classes.root}>
     
      {/*<AppBar position="static">*/}
      {/*  <Tabs*/}
      {/*    value={value}*/}
      {/*    onChange={handleChange}*/}
      {/*    indicatorColor="primary"*/}
      {/*    textColor="primary"*/}
      {/*    variant="scrollable"*/}
      {/*    scrollButtons="auto"*/}
      {/*            aria-label="MCB Scrollable List"*/}
      {/*            className="left-div"*/}
      {/*        >*/}
      {/*            <Tab className="left-div" label="8D Closure Time Report" {...a11yProps(0)} />*/}
      {/*  </Tabs>*/}
          {/*</AppBar>*/}

          <div className="left-div">
              <h3 className="heading">8D Closure Time Report</h3>
          </div>
      <TabPanel value={value} index={0}>
      <BaseReport/>
       
      </TabPanel>
      <TabPanel value={value} index={1}>
       
      </TabPanel>
    </div>
  );
}
